import React, {useContext, useEffect, useState} from "react";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";
import Logo from "../../assets/image/logo.svg";
import EstateList from "./EstateList";
import "../../assets/stylesheets/realestate.css";
import axios from "axios";
import {ContactInfoContext} from "../additional/ContactInfoContext";

function Favorites() {
    const { t, i18n } = useTranslation(["home", "estate"]);
    const { contactInfo } = useContext(ContactInfoContext);

    const [favoriteIds, setFavoriteIds] = useState([]);

    // Load favorite IDs from local storage on mount
    useEffect(() => {
        const storedFavorites = localStorage.getItem("favoriteEstates");
        if (storedFavorites) {
            setFavoriteIds(JSON.parse(storedFavorites));
        }
    }, []);

    return (
        <>
            <Helmet>
                <meta name="description" content={t("favoritesDescribe", { defaultValue: "View your favorite properties on SIEVN Real Estate Agency" })} />
                <link rel="canonical" href={`https://sievn.am/${i18n.language}/favorites`} />
                <title>{t("favoritesTitle", { defaultValue: "Favorite Properties" })}</title>
                <meta property="og:title" content={t("favoritesTitle", { defaultValue: "Favorite Properties" })} />
                <meta property="og:site_name" content="sievn.am" />
                <meta property="og:url" content={`https://sievn.am/${i18n.language}/favorites`} />
                <meta property="og:description" content={t("favoritesDescribe", { defaultValue: "View your favorite properties on SIEVN Real Estate Agency" })} />
                <meta property="og:image" content={Logo} />
                <meta property="og:image:width" content="1200" />
                <meta property="og:image:height" content="630" />
            </Helmet>

            <section className="homepage">
                <div className="home__hero">
                    <img src={contactInfo.homeUrl} alt="Hero background" className="home__hero-image" />
                    <div className="home__hero-overlay">
                        <div className="home__hero-content">
                            <h1 className="home__hero-text2">{t("company-name")}</h1>
                            <h2 className="home__hero-text3">{t("comfort-text")}</h2>
                        </div>
                    </div>
                </div>
                <div className="home__top-estates">
                    <EstateList
                        type="favorites"
                        language={i18n.language}
                        filter={new Map()}
                        query={favoriteIds.join(",")}
                    />
                </div>
            </section>
        </>
    );
}

export default Favorites;